import React from 'react';
import { motion } from 'framer-motion';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl font-bold text-[#2c3e50] mb-8">
            Política de Privacidad
          </h1>
          
          <div className="bg-white rounded-lg shadow-lg p-8 space-y-8">
            <div>
              <p className="text-gray-600 mb-6">
                <strong>Última actualización:</strong> 1 de enero de 2024
              </p>
              
              <p className="text-gray-600 leading-relaxed">
                En AUTOSFERSAN, respetamos su privacidad y nos comprometemos a proteger sus datos personales. 
                Esta política de privacidad explica cómo recopilamos, usamos y protegemos su información.
              </p>
            </div>

            <section>
              <h2 className="text-2xl font-bold text-[#2c3e50] mb-4">
                1. Responsable del Tratamiento
              </h2>
              <div className="text-gray-600 leading-relaxed">
                <p><strong>Empresa:</strong> AUTOSFERSAN</p>
                <p><strong>Dirección:</strong> Calle Isaac Peral, 31, Polígono La Mejostilla, 10004 Cáceres</p>
                <p><strong>Email:</strong> info@autosfersan.com</p>
                <p><strong>Teléfono:</strong> 610 70 15 17</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#2c3e50] mb-4">
                2. Datos que Recopilamos
              </h2>
              <div className="text-gray-600 leading-relaxed space-y-4">
                <p>Recopilamos los siguientes tipos de información:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Datos de identificación:</strong> Nombre, apellidos, DNI</li>
                  <li><strong>Datos de contacto:</strong> Dirección, teléfono, email</li>
                  <li><strong>Datos de navegación:</strong> Información sobre su uso de nuestro sitio web</li>
                  <li><strong>Datos comerciales:</strong> Preferencias de vehículos, historial de consultas</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#2c3e50] mb-4">
                3. Finalidad del Tratamiento
              </h2>
              <div className="text-gray-600 leading-relaxed space-y-4">
                <p>Utilizamos sus datos para:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Gestionar consultas y solicitudes de información</li>
                  <li>Procesar la venta y financiación de vehículos</li>
                  <li>Enviar comunicaciones comerciales (con su consentimiento)</li>
                  <li>Cumplir con obligaciones legales</li>
                  <li>Mejorar nuestros servicios</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#2c3e50] mb-4">
                4. Base Legal
              </h2>
              <div className="text-gray-600 leading-relaxed space-y-4">
                <p>El tratamiento de sus datos se basa en:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Consentimiento:</strong> Para comunicaciones comerciales</li>
                  <li><strong>Ejecución contractual:</strong> Para la venta de vehículos</li>
                  <li><strong>Interés legítimo:</strong> Para mejorar nuestros servicios</li>
                  <li><strong>Cumplimiento legal:</strong> Para obligaciones fiscales y legales</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#2c3e50] mb-4">
                5. Conservación de Datos
              </h2>
              <div className="text-gray-600 leading-relaxed">
                <p>
                  Conservaremos sus datos personales durante el tiempo necesario para cumplir con las 
                  finalidades para las que fueron recopilados, y durante los plazos establecidos por la 
                  legislación aplicable.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#2c3e50] mb-4">
                6. Derechos del Usuario
              </h2>
              <div className="text-gray-600 leading-relaxed space-y-4">
                <p>Usted tiene derecho a:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Acceso:</strong> Conocer qué datos tenemos sobre usted</li>
                  <li><strong>Rectificación:</strong> Corregir datos inexactos</li>
                  <li><strong>Supresión:</strong> Solicitar la eliminación de sus datos</li>
                  <li><strong>Limitación:</strong> Restringir el tratamiento</li>
                  <li><strong>Portabilidad:</strong> Recibir sus datos en formato estructurado</li>
                  <li><strong>Oposición:</strong> Oponerse al tratamiento</li>
                </ul>
                <p>
                  Para ejercer estos derechos, puede contactarnos en info@autosfersan.com
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#2c3e50] mb-4">
                7. Seguridad de los Datos
              </h2>
              <div className="text-gray-600 leading-relaxed">
                <p>
                  Implementamos medidas técnicas y organizativas apropiadas para proteger sus datos 
                  personales contra el acceso no autorizado, alteración, divulgación o destrucción.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#2c3e50] mb-4">
                8. Cookies
              </h2>
              <div className="text-gray-600 leading-relaxed">
                <p>
                  Nuestro sitio web utiliza cookies para mejorar la experiencia del usuario. 
                  Puede configurar su navegador para rechazar cookies, aunque esto puede afectar 
                  la funcionalidad del sitio.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#2c3e50] mb-4">
                9. Terceros
              </h2>
              <div className="text-gray-600 leading-relaxed">
                <p>
                  No compartimos sus datos personales con terceros, excepto cuando sea necesario 
                  para cumplir con nuestras obligaciones contractuales o legales, o con su consentimiento expreso.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#2c3e50] mb-4">
                10. Modificaciones
              </h2>
              <div className="text-gray-600 leading-relaxed">
                <p>
                  Nos reservamos el derecho a modificar esta política de privacidad. Las modificaciones 
                  se publicarán en nuestro sitio web con la fecha de actualización correspondiente.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#2c3e50] mb-4">
                11. Contacto
              </h2>
              <div className="text-gray-600 leading-relaxed">
                <p>
                  Si tiene preguntas sobre esta política de privacidad o sobre el tratamiento de sus 
                  datos personales, puede contactarnos:
                </p>
                <ul className="list-none mt-4 space-y-2">
                  <li><strong>Email:</strong> info@autosfersan.com</li>
                  <li><strong>Teléfono:</strong> 610 70 15 17</li>
                  <li><strong>Dirección:</strong> Calle Isaac Peral, 31, 10004 Cáceres</li>
                </ul>
              </div>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPage;